/**
 * Dispara el modal global de "llegaste al límite" (PlanLimitPrompt) a partir
 * del cuerpo de un error del backend. Para los flujos que NO usan el
 * axiosInstance global (que ya emite el evento solo): servicios con axios
 * directo, fetch o instancias propias de cada módulo.
 *
 * Devuelve true si emitió, para que el llamador no muestre además su propio
 * toast/error con el mismo mensaje.
 *
 * El 400 de SEDE que pide confirmar el cargo (`requiresAddon: true`) NO se
 * emite: ese flujo tiene su confirmación propia en Locales.
 */
export const emitPlanLimitIfAny = (body: any): boolean => {
  if (!body || body.code !== "PLAN_LIMIT_REACHED" || body.requiresAddon === true) {
    return false;
  }
  window.dispatchEvent(
    new CustomEvent("plan-limit-reached", {
      detail: {
        resourceType: body.resourceType,
        current: body.current,
        limit: body.limit,
      },
    })
  );
  return true;
};

/** Emite el modal de límite para un recurso sin datos de uso (se consultan). */
export const emitPlanLimit = (resourceType: string): void => {
  window.dispatchEvent(
    new CustomEvent("plan-limit-reached", { detail: { resourceType } })
  );
};
